export default "__VITE_ASSET__BsIclpsX__"